import { render, staticRenderFns } from "./ErrorInfo.vue?vue&type=template&id=5677f0bf&scoped=true"
import script from "./ErrorInfo.vue?vue&type=script&lang=ts"
export * from "./ErrorInfo.vue?vue&type=script&lang=ts"
import style0 from "./ErrorInfo.vue?vue&type=style&index=0&id=5677f0bf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5677f0bf",
  null
  
)

export default component.exports